import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-unfold-more-icon',
  templateUrl: 'unfold-more-icon.component.html'
})
export class UnfoldMoreIconComponent {
  constructor() {}
}
